<mat-dialog-content>

  <div class="action-section">
    <div>{{subscription.status}}</div>
    <button mat-raised-button (click)="close()" color="primary" class="btn-details">
      Close
    </button>
  </div>

  <div class="cart-table-container">
    <div class="container-header">
      SUBSCRIPTION PAYMENTS
    </div>
  
    <table mat-table [dataSource]="data.payments">
      <ng-container matColumnDef="id">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>
          REFERENCE ID
        </th>
        <td mat-cell *matCellDef="let line">
          <div  class="id-text cell-content">{{ line.serviceId }}</div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="date">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let line">
          <div  class="cell-content">{{ line.timestamp | date:'medium' }}</div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="amount">
        <th class="header-bg" mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let line">
          <div  class="cell-content">{{ line.amount | amount | currency }}</div>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  
  </div>

</mat-dialog-content>

@if(subscription.status !== 'SUBSCRIPTION_CANCELLED') {
  <mat-dialog-actions> 
    @if(subscription.status === 'SUBSCRIPTION_SUSPENDED') {
      <button mat-raised-button (click)="activateSubscription()" color="primary" class="btn-details">
        Activate Subscription
        <mat-icon iconPositionEnd>settings_backup_restore</mat-icon>
      </button>
    }
    @if(subscription.status === 'SUBSCRIBED') {
      <button mat-raised-button (click)="pauseSubscription()" color="primary" class="btn-details">
        Pause Subscription
        <mat-icon iconPositionEnd>pause</mat-icon>
      </button>
    }
    <button mat-raised-button (click)="cancelSubscription()" color="primary" class="btn-details">
      Cancel Subscription
      <mat-icon iconPositionEnd>cancel</mat-icon>
    </button>
  </mat-dialog-actions>
}